import React from "react";
import "../styles/main.css"
import "../styles/variables.css"
import "../styles/docs.css"

import NavHeader from "./NavHeader";


function Docs() {


    return (
        <div className="main-page">
            <NavHeader />
            <div className="title docs-header">
                Documents for ESNers
            </div>
            <div className="docs-structure">
                <div className="docs-element">
                    <div className="docs-icon-wrapper">
                        <i class="uil uil-file-bookmark-alt docs-icon"></i>
                    </div>
                    <div className="docs-title">Regulamento Interno</div>
                    <div className="docs-description">That's how we roll</div>

                </div>
                <div className="docs-element">
                    <div className="docs-icon-wrapper">
                        <i class="uil uil-question docs-icon"></i>
                    </div>
                    <div className="docs-title">ESN 101</div>
                    <div className="docs-description">The ESN holy book</div>
                </div>
                <div className="docs-element">
                    <div className="docs-icon-wrapper">
                        <i class="uil uil-info docs-icon"></i>
                    </div>
                    <div className="docs-title">ESN Wiki</div>
                    <div className="docs-description">STrips, ICE, and other abbreviations</div>

                </div>
                <div className="docs-element">
                    <div className="docs-icon-wrapper">
                        <i class="uil uil-google-drive docs-icon"></i>
                    </div>
                    <div className="docs-title">ESN Drive</div>
                    <div className="docs-description">If you don't know where it is, it's probably here</div>

                </div>
            </div>




        </div>
    );
}
export default Docs;
